import React from 'react';
import { Outlet } from 'react-router-dom';
import { StyledLayout as Layout, StyledContent as Content } from './styles';

const DefaultLayout = () => (
  <Layout>
    <Content>
      <Outlet />
    </Content>
  </Layout>
);

export default DefaultLayout;
